import { Select, Tooltip } from 'antd';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface IOfficeOption {
  id: string;
  name: string;
  regionId: string;
}

interface IOfficeMultiSelectProps {
  value: string[];
  onChange: (value: string[]) => void;
  offices: IOfficeOption[];
  regionIds?: string[];
  loading?: boolean;
  placeholder?: string;
  disabled?: boolean;
  disabledTooltip?: string;
}

export const OfficeMultiSelect: FC<IOfficeMultiSelectProps> = ({
  value,
  onChange,
  offices,
  regionIds = [],
  loading = false,
  placeholder,
  disabled = false,
  disabledTooltip,
}) => {
  const { t } = useTranslation('dashboard.RecruiterDashboard');

  const filteredOptions = useMemo(() => {
    const filteredOffices =
      regionIds.length > 0
        ? offices.filter((office) => regionIds.includes(office.regionId))
        : offices;

    return filteredOffices.map((office) => ({
      value: office.id,
      label: office.name,
    }));
  }, [offices, regionIds]);

  const handleChange = (selectedValues: string[]) => {
    onChange(selectedValues);
  };

  const select = (
    <Select
      mode="multiple"
      value={value}
      onChange={handleChange}
      options={filteredOptions}
      loading={loading}
      style={{ width: '100%', minWidth: 200 }}
      placeholder={placeholder || t('filtersAllOffices', 'All Offices')}
      allowClear
      maxTagCount="responsive"
      disabled={disabled}
    />
  );

  // Wrap in tooltip when disabled
  if (disabled && disabledTooltip) {
    return <Tooltip title={disabledTooltip}>{select}</Tooltip>;
  }

  return select;
};

export default OfficeMultiSelect;
